export const requirements = {
  validJanusAccount: true,
};

export const verifier = () => {
  return false;
};
